import { CheckedProduct } from 'features/products/types/products.types'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type UsePrintProductsMutationProps = {
	handlePrintComponent: () => void
	onSettled: () => void
}

export const usePrintProductsMutation = ({
	handlePrintComponent,
	onSettled
}: UsePrintProductsMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: printProductsMutation } = useMutation({
		mutationFn: (products: CheckedProduct[]) => {
			handlePrintComponent()
			const printed = products.map((item) => {
				return { id: item.id, quantity: item.__print_quantity }
			})

			return axiosPrivate.post(apiRoutes.productsPrint, { products: printed })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Products printed')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		printProductsMutation
	}
}
